import React from 'react';
import { round } from 'lodash';
import { useTranslation } from 'react-i18next';

import type { WorkoutSummaryRichPayload } from './contentCardUtils';

export type { WorkoutSummaryRichPayload as WorkoutSummaryPayload } from './contentCardUtils';

interface Props {
  p: WorkoutSummaryRichPayload;
}

const WorkoutSummaryCard: React.FC<Props> = ({ p }) => {
  const { t } = useTranslation();
  const stats: Array<{ id: string; label: string; value: string }> = [];

  if (p.duration_min != null) {
    stats.push({
      id: 'duration',
      label: t('task.richContext.workoutSummary.duration', { defaultValue: 'Duration' }),
      value: t('task.richContext.workoutSummary.durationValue', {
        defaultValue: '{{minutes}} min',
        minutes: p.duration_min,
      }),
    });
  }
  if (p.steps != null && p.steps > 0) {
    stats.push({
      id: 'steps',
      label: t('task.richContext.workoutSummary.steps', { defaultValue: 'Steps' }),
      value: p.steps.toLocaleString(),
    });
  }
  if (p.calories != null) {
    stats.push({
      id: 'calories',
      label: t('task.richContext.workoutSummary.calories', { defaultValue: 'Calories' }),
      value: t('task.richContext.workoutSummary.caloriesValue', {
        defaultValue: '{{calories}} kcal',
        calories: round(p.calories),
      }),
    });
  }
  if (p.distance_meters != null) {
    stats.push({
      id: 'distance',
      label: t('task.richContext.workoutSummary.distance', { defaultValue: 'Distance' }),
      value: t('task.richContext.workoutSummary.distanceValue', {
        defaultValue: '{{distance}} km',
        distance: round(p.distance_meters / 1000, 2),
      }),
    });
  }

  return (
    <div className="rc-content-body">
      {stats.length > 0 && (
        <div className="rc-stat-row">
          {stats.map(({ id, label, value }) => (
            <div key={id} className="rc-stat-item">
              <span className="rc-stat-value">{value}</span>
              <span className="rc-stat-label">{label}</span>
            </div>
          ))}
        </div>
      )}
      {p.source && (
        <span className="rc-content-meta" style={{ marginTop: 2 }}>
          {t('task.richContext.workoutSummary.source', {
            defaultValue: 'Source: {{source}}',
            source: p.source,
          })}
        </span>
      )}
    </div>
  );
};

export default WorkoutSummaryCard;
